import React from 'react';
import RegistrationCountDown from './RegistrationCountDown';
import { CardInfoBlock } from '../../common/Card';
import style from './index.scss';

export default ({ items, tKeyPrefix }) => (
    <div className={style.infoRow}>
        {items.map(({ countDown, ...item }, idx) =>
            countDown
                ? <RegistrationCountDown
                    key={idx}
                    tKeyPrefix={tKeyPrefix}
                    className={style.infoItem}
                    {...countDown} />
                : <CardInfoBlock key={idx} className={style.infoItem} {...item} />
        )}
    </div>
);
